var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "content" }, [
        _c("p", [
          _c("b", [_vm._v("Subunidad:")]),
          _vm._v("\n      " + _vm._s(_vm.subunidad.nombre) + " -\n      "),
          _c("b", [_vm._v("Formatos:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.subunidad.formatos.join(",")) + " -\n      "
          ),
          _c("b", [_vm._v("Multiples:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.subunidad.multiple ? "Si" : "No") + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.subunidad.multiple
        ? _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Seleccione el folio"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.folio,
                        expression: "folio",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true },
                        expression: "{required:true}",
                      },
                    ],
                    class: { "is-danger": _vm.errors.has("Folio") },
                    attrs: { name: "Folio" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.folio = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { disabled: "" }, domProps: { value: null } },
                      [_vm._v("- Seleccione un folio -")]
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.foliosDisponibles,
                      function (numeroFolio, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: numeroFolio } },
                          [_vm._v(_vm._s(index + 1))]
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c(
            "button",
            {
              staticClass: "button is-success is-fullwidth",
              on: { click: _vm.submit },
            },
            [
              _c("i", { staticClass: "fas fa-file-signature" }),
              _vm._v(" Firmar subunidad\n      "),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _c(
            "button",
            {
              staticClass: "button is-dark is-fullwidth",
              on: { click: _vm.updateDocument },
            },
            [
              _c("i", { staticClass: "fas fa-sync" }),
              _vm._v(" Verificar firmado\n      "),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showFirmando,
            "has-modal-card": "",
            canCancel: false,
          },
          on: {
            "update:active": function ($event) {
              _vm.showFirmando = $event
            },
          },
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c(
              "section",
              { staticClass: "modal-card-body has-text-centered" },
              [
                _c("h1", { staticClass: "title is-4" }, [
                  _c("i", { staticClass: "fas fa-file-signature" }),
                  _vm._v(" Firmando subunidad\n        "),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "subtitle is-5 animated flash" }, [
                  _vm._v("Abriendo firmador"),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "image signar-logo",
                  attrs: { src: "/statics/signar-logo.svg", alt: "" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("p", [
                    _vm._v(
                      'Una vez que haya realizado la firma, Haca clic en "Recargar unidad compuesta" para reflejar los cambios en el sistema.'
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "has-text-info is-size-7" }, [
                    _vm._v("\n            NOTA: Si la descarga\n            "),
                    _c("u", [_vm._v("NO")]),
                    _vm._v(
                      " comenzó, verifique si su navegador está bloqueando los pop-ups.\n            "
                    ),
                    _c("br"),
                    _vm._v(
                      "Recomendamos habilitar los pop-ups para esta página.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-primary is-fullwidth",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.updateDocument()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-sync" }),
                    _vm._v(" Recargar unidad compuesta\n        "),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }